import React, { useEffect } from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
import Aos from 'aos';
import 'aos/dist/aos.css';

const Experience = () => {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  return (
    <>
        <section id='experience' className='experience container'>
            <div className='experience__container'>
                <div data-aos="zoom-in" className='container__heading'>
                    <h4>What Skills I have</h4>
                    <h1>My Experience</h1>
                </div>

                <div data-aos="fade-up" className='content-section box-shadow'>
                    <div className='experience__frontend'>
                        <h3>Frontend Development</h3>
                        <div className='experience__content'>
                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>HTML5</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>CSS3</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Javascript</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Bootstrap</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Material UI</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Styled C.</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>React js</h4>
                                    <small className='text-light'>Intermediate</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Redux</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Api rest</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>BEM</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article>

                            <article className='experience__details'>
                                <BsPatchCheckFill />
                                <div>
                                    <h4>Sass</h4>
                                    <small className='text-light'>Basic</small>
                                </div>
                            </article>
                        </div>
                    </div>
                </div>




            </div>
        </section>
    </>
  )
}

export default Experience